import { render } from "./AdminShell.vue?vue&type=template&id=6fa92c68"
import script from "./AdminShell.vue?vue&type=script&lang=js"
export * from "./AdminShell.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__